import { render, staticRenderFns } from "./minipauta_24.vue?vue&type=template&id=4b8d56ce&"
import script from "./minipauta_24.vue?vue&type=script&lang=js&"
export * from "./minipauta_24.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports